import { Model } from "@quest/platform-murka-phase_2/dist";
import { gameConstants } from "../Constants/gameConstants";

export class GameParserModel extends Model {
  // Default meystery symbol  77 is used.
  private mystrySymbol: number = 77;
  private cascadeTotalWin: number = 0;
  private cascadeResponse: any;
  private cascadingCount: number = 0;
  private cascadeWin: number = 0;
  private currentCascadingReelNumber: number = 0;
  private isCascadingDone: boolean = false;
  private fgBottomBarWin: number = 0;
  private baseGameStops: number[];
  private freeGameStops: number[];
  private cascadeAccumuWin: number = 0;
  private initialBaseReel: number[][] = [];
  private initialFreeReel: number[][] = [];
  private initialSpinningGrid: number[] = [];
  private revealNum: number;
  private triggeredBait: number;
  private baitCount: number;
  private revealedGrid: number[] = [];
  private cascadeIndexNumber: number = 0;
  private symBounds: any;
  private caseCadeLineToggleCount: number = 0;
  private revealAvailable: boolean = false;
  private revealSymOffsets: number[][];
  private revealSymPositions: number[];
  private wildGrid: number[];
  private wildData: any;
  private baseGameTotalWin: number = 0;

  //Collection
  private collectionMeterData151: any;
  private collectionMeterData152: any;
  private collectionMeter151: any;
  private collectionMeter152: any;
  private collectionMeter151BoxMultiplier: any;
  private collectionMeter152BoxMultiplier: any;
  private collectionMeter151MaxLimits: any;
  private collectionMeter152MaxLimits: any;

  private baitData: any;
  private isBaitPresent: boolean;
  private baitPositions: number[];
  private baitSymOffsets: number[][];
  private chestRevealPositions: number[];
  private gameReelGridForStack: number[][];
  private cascadeOffsets: number[][][] = [
    [
      [0, 0],
      [0, 1],
      [0, 2],
      [0, 3],
      [0, 4],
      [0, 5],
      [0, 6],
      [0, 7],
      [1, 0],
      [1, 1],
      [1, 2],
      [1, 3],
      [1, 4],
      [1, 5],
      [1, 6],
      [1, 7],
      [2, 0],
      [2, 1],
      [2, 2],
      [2, 3],
      [2, 4],
      [2, 5],
      [2, 6],
      [2, 7],
      [3, 0],
      [3, 1],
      [3, 2],
      [3, 3],
      [3, 4],
      [3, 5],
      [3, 6],
      [3, 7],
      [4, 0],
      [4, 1],
      [4, 2],
      [4, 3],
      [4, 4],
      [4, 5],
      [4, 6],
      [4, 7],
    ],
  ];

  public setWinSymBounds(value: any): void {
    this.symBounds = value;
  }

  public getWinSymBounds(): any {
    return this.symBounds;
  }
  public setBaseGameTotalWin(value: number): void {
    this.baseGameTotalWin = value;
  }

  public getBaseGameTotalWin(): number {
    return this.baseGameTotalWin;
  }

  /**
   * Method to save cascade line toggle count.
   * @param Number
   */
  public setCascadeLineToggleCount(data: number) {
    this.caseCadeLineToggleCount = data;
  }

  /**
   * Method to return cascade line toggle count.
   * @returns Number
   */
  public getCascadeLineToggleCount(): number {
    return this.caseCadeLineToggleCount;
  }

  public getInitialBaseReel(): number[][] {
    return this.initialBaseReel;
  }
  public setInitialBaseReel(value: number[][]) {
    this.initialBaseReel = value;
  }
  public getInitialFreeReel(): number[][] {
    return this.initialFreeReel;
  }
  public setInitialFreeReel(value: number[][]) {
    this.initialFreeReel = value;
  }

  public setMysterySymbol(value: number): void {
    this.mystrySymbol = value;
  }
  public getMysterySymbol(): number {
    return this.mystrySymbol;
  }

  /**
   * Method returns basegame reel stops
   */
  public getBaseGameStops(): number[] {
    return this.baseGameStops;
  }
  public setBaseGameStops(value: number[]): void {
    this.baseGameStops = value;
  }

  /**
   * Method returns total cascade win
   */
  public getTotalCascadeWin(): number {
    return this.fgBottomBarWin;
  }
  public setTotalCascadeWin(value: number): void {
    this.fgBottomBarWin = value;
  }

  public getCurrentCascadingReelNumber(): number {
    return this.currentCascadingReelNumber;
  }

  /**
   * This model will set cascade status
   * @returns
   */
  public setCurrentCascadingReelNumber(value: number): void {
    this.currentCascadingReelNumber = value;
  }
  /**
   * This model will return cascade offsets
   * @returns
   */
  public getCascadeOffsets(): number[][][] {
    return this.cascadeOffsets;
  }

  /**
   * This model will set cascade offsets
   * @returns
   */
  public setCascadeOffsets(value: number[][][]): void {
    this.cascadeOffsets = value;
  }

  /**
   * This model will return cascade offsets
   * @returns
   */
  public getCascadeWin(): any {
    return this.cascadeWin;
  }

  /**
   * This model will set cascade offsets
   * @returns
   */
  public setCascadeWin(value: any): void {
    this.cascadeWin = value;
  }

  /**
   * This model will return cascade frequencey
   * @returns
   */
  public getCascadingCount(): number {
    return this.cascadingCount;
  }

  /**
   * This model will set cascade frequencey
   * @returns
   */
  public setCascadingCount(value: number): void {
    this.cascadingCount = value;
  }

  /**
   * store cascade consolodated spin response
   */
  public getCascadeResponse(): any {
    return this.cascadeResponse;
  }
  public setCascadeResponse(value: any): void {
    this.cascadeResponse = value;
  }

  /**
   * This model will return cascade offsets
   */
  public getCascadeTotalWin(): any {
    return this.cascadeTotalWin;
  }
  /**
   * This model will set cascade offsets
   */
  public setCascadeTotalWin(value: any): void {
    this.cascadeTotalWin = value;
  }

  /**
   * This model will return cascade status
   * @returns
   */
  public getCascadingStatus(): boolean {
    return this.isCascadingDone;
  }

  /**
   * This model will set cascade status
   */
  public setCascadingStatus(value: boolean): void {
    this.isCascadingDone = value;
  }

  /**
   * Method returns freegame reel stops
   */
  public getFreeGameStops(): number[] {
    return this.freeGameStops;
  }
  public setFreeGameStops(value: number[]): void {
    this.freeGameStops = value;
  }

  /**
   * This model will return cascade accumulated win
   */
  public getCascadeAccumulatedWin(): any {
    return this.cascadeAccumuWin;
  }

  /**
   * This model will set cascade accumulated win
   */
  public setCascadeAccumulatedWin(value: any): void {
    this.cascadeAccumuWin = value;
  }
  public setIsFreeSpintriggered(value: boolean) {
    this.freeSpinTrigger = value;
  }
  public setInitialSpinningGrid(grid: number[]): void {
    this.initialSpinningGrid = grid;
  }
  public getInitialSpinningGrid(): number[] {
    return this.initialSpinningGrid;
  }
  public setRevealSymNum(value: number): void {
    this.revealNum = value;
  }
  public getRevealSymNum(): number {
    return this.revealNum;
  }
  public setRevealedGrid(value: number[]): void {
    this.revealedGrid = value;
  }
  public getRevealedGrid(): number[] {
    return this.revealedGrid;
  }
  public setTriggeredBait(value: number): void {
    this.triggeredBait = value;
  }
  //
  public getTriggeredBait(): number {
    return this.triggeredBait;
  }
  public setCascadeNumber(data: number): void {
    this.cascadeIndexNumber = data;
  }
  public getCascadeNumber(): number {
    return this.cascadeIndexNumber;
  }
  /**
   * Add to get base game reel grid for stack
   */
  public getGameGridForStack(): number[][] {
    return this.gameReelGridForStack;
  }

  /**
   * Add to set base game reel grid for stack
   */
  public setGameGridForStack(value: number[][]): void {
    this.gameReelGridForStack = value;
  }

  public setRevealAvailable(value: boolean): void {
    this.revealAvailable = value;
  }
  public getRevealAvailable(): boolean {
    return this.revealAvailable;
  }
  public setRevealSymPositions(value: number[]): void {
    this.revealSymPositions = value;
  }
  public getRevealSymPositions(): number[] {
    return this.revealSymPositions;
  }
  public setRevealSymOffsets(data: number[][]): void {
    this.revealSymOffsets = data;
  }

  public getRevealSymOffsets(): number[][] {
    return this.revealSymOffsets;
  }

  public setWildGrid(grid: number[]): void {
    this.wildGrid = grid;
  }

  public getWildGrid(): number[] {
    return this.wildGrid;
  }

  public setWildData(value: any) {
    this.wildData = value;
  }

  public getWildData(): any {
    return this.wildData;
  }

  public setBaitData(value: any) {
    this.baitData = value;
  }

  public getBaitData(): any {
    return this.baitData;
  }

  public setBaitPositions(value: number[]): void {
    this.baitPositions = value;
  }

  public getBaitPositions(): number[] {
    return this.baitPositions;
  }

  public setBaitCount(value: number): void {
    this.baitCount = value;
  }

  public getBaitCount(): number {
    return this.baitCount;
  }

  public getBaitSymId(triggeredBait: number): number {
    if (triggeredBait === 151) {
      return gameConstants.BAIT_RED_ID;
    } else if (triggeredBait === 152) {
      return gameConstants.BAIT_GREEN_ID;
    }
  }

  public setIsBaitPresent(value: boolean): void {
    this.isBaitPresent = value;
  }

  public getIsBaitPresent(): boolean {
    return this.isBaitPresent;
  }

  public setBaitSymOffsets(value: number[][]): void {
    this.baitSymOffsets = value;
  }

  public getBaitSymOffsets(): number[][] {
    return this.baitSymOffsets;
  }

  /**
   *
   * hold and respin parsing getter setters
   *
   */

  // store total win for respin
  private IsHoldAndRespinAvailable: boolean = false;
  public setIsHoldAndRespinAvailable(value: boolean): void {
    this.IsHoldAndRespinAvailable = value;
  }
  public getIsHoldAndRespinAvailable(): boolean {
    return this.IsHoldAndRespinAvailable;
  }
  // store total win for respin
  private fishingTimeTotalWin: number = 0;
  public setFishingTimeTotalWin(value: number): void {
    this.fishingTimeTotalWin = value;
  }
  public getFishingTimeTotalWin(): number {
    return this.fishingTimeTotalWin;
  }
  //store total count for respin
  private fishingTimeTotalCount: number = 0;
  public setFishingTimeTotalCount(value: number): void {
    this.fishingTimeTotalCount = value;
  }
  public getFishingTimeTotalCount(): number {
    return this.fishingTimeTotalCount;
  }

  //store spins data
  private fishingTimeSpinsData: any;
  public setFishingTimeSpinsData(value: any): void {
    this.fishingTimeSpinsData = value;
  }
  public getFishingTimeSpinsData(): any {
    return this.fishingTimeSpinsData;
  }

  // Method returns current respin count
  private currentReSpin: number = 0;
  public setCurrentReSpinIndex(value: number): void {
    this.currentReSpin = value;
  }
  public getCurrentReSpinIndex(): number {
    return this.currentReSpin;
  }

  // store grid after symbols moving
  private reelGridMovingSymbol: number[] = [];
  public setReelGridAfterMovingSymbol(value: number[]): void {
    this.reelGridMovingSymbol = value;
  }
  public getReelGridAfterMovingSymbol(): number[] {
    return this.reelGridMovingSymbol;
  }
  //to store fishes stopping data for current spin
  private currentSpinFishPosition: number[];
  public setCurrentSpinFishPosition(value: number[]): void {
    this.currentSpinFishPosition = value;
  }
  public getCurrentSpinFishPosition(): number[] {
    return this.currentSpinFishPosition;
  }
  //to weather counter is reset or not
  private isSpinsReset: boolean;
  public setIsSpinsReset(value: boolean): void {
    this.isSpinsReset = value;
  }
  public getIsSpinsReset(): boolean {
    return this.isSpinsReset;
  }
  //to store total fishes landed fish
  private totalLandedFish: number;
  public setTotalLandedFish(value: number): void {
    this.totalLandedFish = value;
  }
  public getTotalLandedFish(): number {
    return this.totalLandedFish;
  }
  //to store big fish is awarded ib current spin or not
  private isBigFishAwarded: boolean;
  public setIsBigFishAwarded(value: boolean): void {
    this.isBigFishAwarded = value;
  }
  public getIsBigFishAwarded(): boolean {
    return this.isBigFishAwarded;
  }
  //to store initial stopping grid
  private HnRStoppingReelGrid: number[];
  public setHnRStoppingReelGrid(value: number[]): void {
    this.HnRStoppingReelGrid = value;
  }
  public getHnRStoppingReelGrid(): number[] {
    return this.HnRStoppingReelGrid;
  }
  //to store initial stopping grid
  private HnRAccumulatedAmount: number;
  public setHnRAccumulatedAmount(value: number): void {
    this.HnRAccumulatedAmount = value;
  }
  public getHnRAccumulatedAmount(): number {
    return this.HnRAccumulatedAmount;
  }
  //to store initial stopping grid
  private bigFishData: any;
  public setBigFishData(value: any): void {
    this.bigFishData = value;
  }
  public getBigFishData(): any {
    return this.bigFishData;
  }

  public getChestRevealPositions(): number[] {
    return this.chestRevealPositions;
  }

  public setChestRevealPositions(value: number[]): void {
    this.chestRevealPositions = value;
  }
  //to store respin spin counter
  private fishingTimeSpinCounter: any;
  public setFishingTimeSpinCounter(value: any): void {
    this.fishingTimeSpinCounter = value;
  }
  public getFishingTimeSpinCounter(): any {
    return this.fishingTimeSpinCounter;
  }
  //to auto bait moving positions
  private positionBaitPosition: any;
  public setPositionBaitPosition(value: any): void {
    this.positionBaitPosition = value;
  }
  public getPositionBaitPosition(): any {
    return this.positionBaitPosition;
  }

  public getCollectionMeterData(collection: number): any {
    if (collection === 151) {
      return this.collectionMeterData151;
    } else {
      return this.collectionMeterData152;
    }
  }
  public setCollectionMeterData151(value: any): void {
    this.collectionMeterData151 = value;
  }

  public setCollectionMeterData152(value: any): void {
    this.collectionMeterData152 = value;
  }

  public setCollectionMeter151(value: any): void {
    this.collectionMeter151 = value;
  }

  public getCollectionMeter(collection: number): any {
    if (collection === 151) {
      return this.collectionMeter151;
    } else {
      return this.collectionMeter152;
    }
  }
  public setCollectionMeter152(value: any): void {
    this.collectionMeter152 = value;
  }

  public setCollectionMeter151BoxMultiplier(value: any): void {
    this.collectionMeter151BoxMultiplier = value;
  }

  public setCollectionMeter152BoxMultiplier(value: any): void {
    this.collectionMeter152BoxMultiplier = value;
  }

  public getCollectionMeterBoxMultiplier(collection: number): any {
    if (collection === 151) {
      return this.collectionMeter151BoxMultiplier;
    } else {
      return this.collectionMeter152BoxMultiplier;
    }
  }

  public setCollectionMeter152MaxLimits(value: any): void {
    this.collectionMeter152MaxLimits = value;
  }

  public getCollectionMeterMaxLimits(collection: number): any {
    if (collection === 151) {
      return this.collectionMeter151MaxLimits;
    } else {
      return this.collectionMeter152MaxLimits;
    }
  }

  public setCollectionMeter151MaxLimits(value: any): void {
    this.collectionMeter151MaxLimits = value;
  }
  //to auto bait moving positions
  private bigFishWinAmount: any;
  public setBigFishWinAmount(value: any): void {
    this.bigFishWinAmount = value;
  }
  public getBigFishWinAmount(): any {
    return this.bigFishWinAmount;
  }
  //to auto bait moving positions
  private holdNRespinBoxMultipliers: any;
  public setHoldNRespinBoxMultipliers(value: any): void {
    this.holdNRespinBoxMultipliers = value;
  }
  public getHoldNRespinBoxMultipliers(): any {
    return this.holdNRespinBoxMultipliers;
  }

  //collection payout data
  private collectionPayoutData: any;
  public setCollectionPayoutData(value: any): void {
    this.collectionPayoutData = value;
  }
  public getCollectionPayoutData(): any {
    return this.collectionPayoutData;
  }

  //collection payout data
  private collectionCreditsWon: any;
  public setCollectionCreditsWon(value: number): void {
    this.collectionCreditsWon = value;
  }
  public getCollectionCreditsWon(): any {
    return this.collectionCreditsWon;
  }

  private awardedBigFishes: any;
  public setAwardedBigFishes(value: any): void {
    this.awardedBigFishes = value;
  }
  public getAwardedBigFishes(): any {
    return this.awardedBigFishes;
  }
  private previousAwardedBigFishes: any;
  public setPreviousAwarededBigFishes(value: any): void {
    this.previousAwardedBigFishes = value;
  }
  public getPreviousAwarededBigFishes(): any {
    return this.previousAwardedBigFishes;
  }
  private isJackpotAvailable: boolean;
  public setIsJackpotAvailable(value: boolean): void {
    this.isJackpotAvailable = value;
  }
  public getIsJackpotAvailable(): boolean {
    return this.isJackpotAvailable;
  }
  private JackpotAmt: number = 0;
  public setJackpotAmt(value: number): void {
    this.JackpotAmt = value;
  }
  public getJackpotAmt(): number {
    return this.JackpotAmt;
  }
  private lastCascadeGridForFg: number[][];
  public setLastCascadeGridForFg(value: number[][]): void {
    this.lastCascadeGridForFg = value;
  }
  public getLastCascadeGridForFg(): number[][] {
    return this.lastCascadeGridForFg;
  }
  private RemovedBigFish: any;
  public setRemovedBigFish(value: any): void {
    this.RemovedBigFish = value;
  }
  public getRemovedBigFish(): any {
    return this.RemovedBigFish;
  }
  private MetersAwarded151: any;
  public setMetersAwarded151(value: any): void {
    this.MetersAwarded151 = value;
  }
  private MetersAwarded152: any;
  public setMetersAwarded152(value: any): void {
    this.MetersAwarded152 = value;
  }
  public getMetersAwarded(collection:number): any {
    if (collection === 151) {
      return this.MetersAwarded151;
    } else {
      return this.MetersAwarded152;
    }
  }
}
